"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const en_US_1 = __importDefault(require("date-fns/locale/en-US")); //
const dateEnUs = {
    name: 'en-US',
    locale: en_US_1.default
};
exports.default = dateEnUs;
